import barba from '@barba/core'
import gsap from 'gsap'
import ContactForm from './ContactForm'
import Discover from './Discover'
import Marquee from './Marquee'
import Popups from './Popups'
import ScrollArrows from './ScrollArrows'

export default class Animation {
  static init() {
    const body = document.body

    barba.init({
      sync: true,
      transitions: [
        {
          name: 'opacity-transition',

          async leave(data) {
            const done = this.async()

            // old page content get out
            pageTransition()

            // set delay between old and new page
            await delay(400)
            done()
          },

          async enter(data) {
            // new page content come in
            contentAnimation()

            // update page classes
            const newClasses =
              data.next.container.dataset.barbaBodyClasses.split(' ')

            if (newClasses.indexOf('page--home') !== -1) {
              Discover.init()
              Marquee.init()
            } else {
              setTimeout(() => {
                ScrollArrows.init()
              }, 500)
            }

            if (newClasses.indexOf('page--contatti') !== -1) {
              ContactForm.init()
            }

            Popups.init()

            body.className = ''
            body.classList.add(...newClasses)
          },

          async once(data) {
            contentAnimation()
          },
        },
      ],
    })
  }
}

function pageTransition() {
  const tl = gsap.timeline()

  if (document.querySelector('.section-bottom')) {
    tl.to('.section-bottom', {
      duration: 0.1,
      opacity: 0,
      visibility: 'hidden',
    })
  }

  if (document.querySelector('.section-title')) {
    tl.to('.section-title', {
      delay: 0.1,
      duration: 0.1,
      opacity: 0,
      visibility: 'hidden',
    })
  }
}

function contentAnimation() {
  const tl = gsap.timeline()

  if (document.querySelector('.section-title')) {
    tl.fromTo(
      '.section-title',
      {
        opacity: 0,
        visibility: 'hidden',
      },
      {
        duration: 0,
        opacity: 1,
        visibility: 'visible',
      }
    )
  }

  if (document.querySelector('.section-bottom')) {
    tl.fromTo(
      '.section-bottom',
      {
        opacity: 0,
        visibility: 'hidden',
      },
      {
        delay: 0.2,
        duration: 0.1,
        opacity: 1,
        visibility: 'visible',
      }
    )
  }
}

function delay(n) {
  n = n || 2000
  return new Promise((done) => {
    setTimeout(() => {
      done()
    }, n)
  })
}
